import { useEffect, useState } from 'react';
import { SocketMessage, useAblyMessageListener } from './useAblyMessageListener';
import { useAppDispatch, useAppSelector } from '../types/hooks';
import { setSocketsConnected } from '../store/slices/settings';
import useWebSocket from 'react-use-websocket';
import { userId$ } from '../store/slices/user';

const Sockets = () => {
    const d = useAppDispatch();

    const userId = useAppSelector(userId$);
    const { deviceUniqueId } = useAppSelector((s) => s.settings);
    const ablyMessageListener = useAblyMessageListener('/map');

    const [socketUrl, setSocketUrl] = useState(
        `wss://${process.env.REACT_APP_NODEJS_URL}?userId=${userId}&deviceId=${deviceUniqueId}`,
    );

    const { lastJsonMessage } = useWebSocket(socketUrl, {
        onOpen: () => {
            d(setSocketsConnected(true));
        },
        onClose: () => {
            d(setSocketsConnected(false));
        },
        onError: (event: WebSocketEventMap['error']) => {
            console.log('on ws error', event);
        },
        reconnectInterval: 10,
        reconnectAttempts: 10,
        shouldReconnect: () => true,
    });

    useEffect(() => {
        if (lastJsonMessage) {
            ablyMessageListener(lastJsonMessage as SocketMessage);
        }
    }, [lastJsonMessage]);

    useEffect(() => {
        return () => {
            // console.log('SHOULD close s');
        };
    }, []);

    useEffect(() => {
        setSocketUrl(`wss://${process.env.REACT_APP_NODEJS_URL}?userId=${userId}&deviceId=${deviceUniqueId}`);
    }, [userId, deviceUniqueId]);

    return null;
};

export default Sockets;
